import { formatDateToLocale, Formats } from '@toggle/helpers';
import { EarningsItemBase } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLanguageStore } from '~/stores/use-language-store/useLanguageStore';
import { formatNumberWithUnit } from '~/widgets/earnings/utils/utils';

import styles from './EarningsInsightSection.module.scss';

export interface PreviewContentProps {
  earningsData: EarningsItemBase;
}

export const PreviewContent = ({ earningsData }: PreviewContentProps) => {
  const { t } = useTranslation(['widget']);
  const languageSetting = useLanguageStore(state => state.languageSetting);

  const formattedDate = earningsData.reporting_date
    ? formatDateToLocale(
        languageSetting,
        new Date(earningsData.reporting_date),
        Formats['MMMM d']
      )
    : '-';

  const reportPeriod =
    earningsData.fiscal_period && earningsData.fiscal_year
      ? `${earningsData.fiscal_period} ${earningsData.fiscal_year}`
      : '-';

  return (
    <>
      <div className={styles.metricContainer}>
        <span className={styles.metricLabel}>
          {t('widget:assetOverview.earningsSection.nextReportDate')}
        </span>
        <span className={styles.metricValue}>{formattedDate}</span>
      </div>
      <div className={styles.metricContainer}>
        <span className={styles.metricLabel}>
          {t('widget:assetOverview.earningsSection.reportPeriod')}
        </span>
        <span className={styles.metricValueMono}>{reportPeriod}</span>
      </div>
      <div className={styles.metricContainer}>
        <span className={styles.metricLabel}>
          {t('widget:assetOverview.earningsSection.epsEstimate')}
        </span>
        <span className={styles.metricValueMono}>
          {formatNumberWithUnit(earningsData.eps?.estimate)}
          <span className={styles.currencyLabel}>{earningsData.currency ?? 'USD'}</span>
        </span>
      </div>
      <div className={styles.metricContainer}>
        <span className={styles.metricLabel}>
          {t('widget:assetOverview.earningsSection.revenueEstimate')}
        </span>
        <span className={styles.metricValueMono}>
          {formatNumberWithUnit(earningsData.revenue?.estimate)}
          <span className={styles.currencyLabel}>{earningsData.currency ?? 'USD'}</span>
        </span>
      </div>
    </>
  );
};
